/**
 * A date as the `date` input wants it: `YYYY-MM-DD`, in the local calendar.
 *
 * Not `toISOString().slice(0, 10)`, which is UTC: a venue in Warsaw looking at
 * its page at half past eleven at night would have been offered tomorrow.
 *
 * Node-safe and pure, because both callers are different runtimes: the
 * editor's preview in a browser and `scripts/prerender.tsx` in Node.
 */
export function isoDay(date: Date = new Date()): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

/**
 * Every quarter hour from one time to another, both ends included.
 *
 * `HH:mm` in and out, so the list is the same strings the form sends. A venue
 * that closes after midnight gives a `to` before its `from`; the list then runs
 * to the end of the day, because a booking form is for a day and the small
 * hours belong to the next one.
 */
export function quarterHours(from: string, to: string): string[] {
  const minutes = (value: string) => {
    const [hours, mins] = value.split(':').map(Number)
    return hours * 60 + mins
  }
  const label = (value: number) =>
    `${String(Math.floor(value / 60)).padStart(2, '0')}:${String(
      value % 60
    ).padStart(2, '0')}`

  const start = minutes(from)
  const end = minutes(to) > start ? minutes(to) : 23 * 60 + 45
  const slots: string[] = []
  for (let at = start; at <= end; at += 15) slots.push(label(at))
  return slots
}
